import { withStyles } from "@material-ui/core/styles";
import Lista from "./Lista";
import styles from "./styles";

export default withStyles(styles)(Lista);
